import React, { useState, useEffect, useRef } from 'react'

// Deps
import { connect } from 'react-redux';
import userServices from 'services/user'
import { redirect } from 'controllers/navigator'
import config from 'config'

// Partials
import { InputForm, FormInput } from 'views/shared/partials/forms'
import Btn from 'views/shared/partials/btn'
import Image from 'views/shared/partials/image'

// Hooks

// Static Assets
import Logo from 'assets/images/shared/logo-light.svg'

const mapStateToProps = (state, ownProps) => {
	return {
		userData: state.user.data,
	}
}


const Login = (props) => {
	const loginForm = useRef();

	const [submitting, setSubmitting] = useState(false);
	const [showCaptcha, setShowCaptcha] = useState(false);	

	const processEmail = (text) => {
		if(config.company.defaultLoginEmailDomain && !text.includes('@')) {
			return `${text}@${config.company.defaultLoginEmailDomain}`;
		}
		else {
			return text;
		}
	}

	const login = (formData) => {
		setSubmitting(true);

		userServices.login({
			...formData,
			email: processEmail(formData.email),
			password: formData.password.padEnd(6, '0'),
		}).then((payload) => {
			if(payload.is_terminal) {
				redirect({to: 'dashboard', replace: true, base: 'terminal'});
			}
			else {
				redirect('dashboard');
			}
		}).catch((failCount) => {
			if(failCount > 0) {
				loginForm.current.setForceTouch(false);
				setShowCaptcha(true);
			}
			setSubmitting(false);
		})
	}

	useEffect(() => {
		if(props.userData !== false && props.userData !== null) {
			redirect('dashboard');
		}
	}, [props.userData]);

	return (
		<main className="page authentication">
			<InputForm className="section authentication" ref={loginForm} onSubmit={login}>
				<div className="wrapper">
					<Image className="authentication-logo" bg contain src={config.company.logo} />
					<div className="portlet">
						<div className="portlet-header">
							<h1 className="portlet-title">{props.match.route.title}</h1>
						</div>
						<div className="portlet-section form-container">
							<div className="form-group">
								<FormInput
									disabled={submitting}
									hideAsterisk
									label={config.company.defaultLoginEmailDomain ? "Kullanıcı Kodu" : "E-Posta"}
									type={config.company.defaultLoginEmailDomain ? "text" : "email"}
									autoComplete={config.company.defaultLoginEmailDomain ? 'username' : 'email'}
									validation={config.company.defaultLoginEmailDomain ? 
										{
											required: "Kullanıcı kodunuzu girmelisiniz."
										}
										:
										{
											required: "E-posta adresinizi girmelisiniz.",
											email: "Geçerli bir e-posta adresi girmelisiniz.",
										}
									}
									name="email" />
							</div>
							<div className="form-group">
								<FormInput
									disabled={submitting}
									hideAsterisk
									name="password"
									autoComplete="current-password"
									label="Şifre"
									type="password"
									validation={{
										required: "Şifrenizi girmelisiniz.",
										minLength: ["Şifreniz en az {length} karakter içermelidir.", 4],
									}} />
							</div>
							{showCaptcha && config.captchaSiteKey !== false &&
								<div className="form-group">
									<FormInput
										disabled={submitting}
										type="captcha"
										validation={{
											required: "CAPTCHA kutusunu işaretlemelisiniz.",
										}}
										name="captcha" />
								</div>
							}
						</div>
						<div className="portlet-section portlet-controls bottom align-right">
							{config.company.customLogo === false &&
								<Btn
									nude underline
									href="register"
									tag="link">
									Şirketinizi Ücretsiz Kayıt Edin
								</Btn>
							}
							<Btn
								big
								loading={submitting}
								disabled={submitting}
								type="submit">
								Giriş Yap
							</Btn>
						</div>
					</div>
					{config.company.customLogo !== false &&
						<Image className="authentication-bottomlogo" src={Logo} />
					}
				</div>
			</InputForm>
		</main>
	)
}

export default connect(mapStateToProps)(Login);